import { gql } from '@apollo/client';
import type { Report2SummarySectionFragment } from '../../../../../generated/types';
import { SectionGroup, SectionInsights } from '../../common';
import SummaryCover from './SummaryCover';
import SummaryKeyMetrics from './SummaryKeyMetrics';

export const REPORT2_SUMMARY_SECTION_FRAGMENT = gql`
  fragment Report2SummarySection on ReportSummarySection {
    id
    title
    state
    subSections {
      ...Report2SummaryCover
      ...Report2SummaryKeyMetrics
      ...Report2SectionInsights
    }
  }
`;

interface Props {
  section: Report2SummarySectionFragment;
}

export const SummarySection = ({ section }: Props) => {
  return (
    <SectionGroup id={section.id}>
      {section.subSections.map(subSection => {
        switch (subSection.__typename) {
          case 'ReportSummaryCover':
            return <SummaryCover key={subSection.id} />;
          case 'ReportSummaryKeyMetrics':
            return <SummaryKeyMetrics key={subSection.id} section={subSection} />;
          case 'ReportSectionInsights':
            return <SectionInsights key={subSection.id} section={subSection} />;
          default:
            return null;
        }
      })}
    </SectionGroup>
  );
};
